









































































































import { Component, Vue } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import GenericEdit from "@/core/Generics/GenericEdit";
import AnnoucementType from "@/models/annoucement/annoucementType.model";
@Component
export default class AnnoucementTypeEdit extends GenericEdit<AnnoucementType> {
  constructor() {
    super();
    this.controller = "AnnoucementType";
    this.model = new AnnoucementType();
  }
}
